import productInstance from '../instance'

const importLieferando = (data) => {
  return productInstance.post('/import/', data)
}

export default importLieferando
